import { courseSlugToName } from './common'

const COURSE_SLUG_TO_META_DESCRIPTION: Record<string, string> = {
  sat: "If you're looking for an SAT prep course, connect with a tutor on Schoolhouse.world. Our peer tutoring platform offers high-quality virtual tutoring for free!",
  geometry:
    'Find great geometry help with a Schoolhouse tutor. Our peer tutoring platform offers high-quality virtual tutoring for free. Click here to learn geometry!',
  statistics:
    'Get free, live tutoring from passionate volunteers in single sessions or ongoing series. Tackle homework, prep for tests, or deepen your understanding.',
  algebra:
    'Struggling with Algebra 1? Get free online tutoring to build confidence, understand tough concepts, and improve your grades.',
  algebra2:
    'Struggling with Algebra 2? Get free online tutoring to build confidence, understand tough concepts, and improve your grades.',
}

export default function getCourseMetaDescription(courseSlug: string | null): string {
  if (courseSlug == null || courseSlugToName[courseSlug] == null) {
    return (
      'Find a great tutor on Schoolhouse. Our peer tutoring platform offers high-quality virtual tutoring for free. ' +
      'Click here to learn more!'
    )
  }
  if (courseSlug in COURSE_SLUG_TO_META_DESCRIPTION) {
    return COURSE_SLUG_TO_META_DESCRIPTION[courseSlug]
  }
  const courseName = courseSlugToName[courseSlug]
  return (
    `Find a great ${courseName} tutor on Schoolhouse.` +
    `Our peer tutoring platform offers high-quality virtual tutoring for free! Click here to learn ${courseName}.`
  )
}
